const translations = {
  "en": {
    "KDJ": "KDJ"
  },
  "zh-tw": {
    "KDJ": "KDJ"
  }
};

export default translations;
